import React, {useEffect, useState} from 'react';
import DropdownTreeSelect from "react-dropdown-tree-select";
import "../../../assets/css/pages/tree-select.css";

const findAllAncestors = (flattenedOptions, id, res) => {
  let parent = flattenedOptions.find(option => option.value == id)
  if (parent) {
    res.push(parent.value)
    if (parent.parent_id) {
      findAllAncestors(flattenedOptions, parent.parent_id, res)
    }
  }
  return res;
}

const assignObjectPaths = (obj, stack, selectedValue, ancestors) => {
  if (obj?.value && ancestors?.includes(obj?.value)) {
    obj.expanded = true;
  } else delete obj.expanded;

  Object.keys(obj).forEach(key => {
    const node = obj[key];
    if (typeof node === "object") {
      if (node.value == selectedValue) {
        node.checked = true;
      } else {
        delete node.checked;
      }
      node.path = stack ? `${stack}.${key}` : key;
      assignObjectPaths(node, node.path, selectedValue, ancestors);
    }
  });
};


export default function ({
                           label,
                           errorMessage,
                           options = [],
                           flattenedOptions = [],
                           placeholder = 'აირჩიეთ',
                           classes = '',
                           callback = null,
                           required = false,
                           disabled = false,
                           value,
                           state,
                           setState
                         }) {

  const handleChange = (selected) => {
    const val = selected?.checked ? selected?.value : null;
    let ancestors = [];
    if (val) {
      ancestors = findAllAncestors(flattenedOptions, val, [])
    }
    setState(val);
    assignObjectPaths(options, null, parseInt(val), ancestors);
    if (callback) callback(val)
  }

  useEffect(() => {
    if (value && !state) {
      setState(value)
      let ancestors = findAllAncestors(flattenedOptions, parseInt(value), [])
      assignObjectPaths(options, null, parseInt(value), ancestors);
    }
  }, [value])

  return (
    <div className={`fv-row${classes ? " " + classes : ''}`}>
      <label className="form-label fs-6 fw-bolder text-dark">
        {label}
      </label>
      <DropdownTreeSelect
        data={options}
        onChange={(selected) => handleChange(selected)}
        mode="radioSelect"
        disabled={disabled}
      />

      {errorMessage && (
        <div className="fv-plugins-message-container invalid-feedback">
          <div>{errorMessage}</div>
        </div>
      )}
    </div>
  )
}